enum AdminBillableServiceGridSortColumn {
    Site,
    Name,
    Price,
    Number
}

export { AdminBillableServiceGridSortColumn };
